<template>
  <a-modal :visible="visible" @ok="process" @cancel="cancel" :width="getScreen ? '90%' : '90%'" :confirmLoading="loading.confirm"
    :footer="false" :maskClosable="false">
    <span slot="title"> <a-icon type="reconciliation" />&nbsp;Detil LKPD</span>

    <a-row :gutter="24">
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <ul class="m-list-wrapper bordered">
          <li>
            <span class="m-list-title" for>Assignee</span>
            <span class="m-list-desc">{{ dtl.header.tlc }}</span>
          </li>
          <!-- <li>
            <span class="m-list-title" for>Value LKPD incentive In/Out</span>
            <span class="m-list-desc">{{ formatCurrency('IDR',dtl.header.insentif_pd) }} / {{ formatCurrency('USD',dtl.header.insentif_luar_negeri) }}</span>
          </li> -->
          <li>
            <span class="m-list-title" for>Total incentive PD IDR/USD</span>
            <span class="m-list-desc">{{ dtl.header.total_pd && Number(dtl.header.total_pd)>0 ? formatCurrency('IDR',dtl.header.total_pd) : formatCurrency('USD',dtl.header.total_ln) }}</span>
          </li>
        </ul>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <ul class="m-list-wrapper bordered">
          <li>
            <a-row :gutter="24">
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <span class="m-list-title" for>Create Date</span>
                <span class="m-list-desc">{{ dtl.header.tgl_buat }}</span>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <span class="m-list-title" for>Total Days</span>
                <span class="m-list-desc">{{ dtl.header.hari }}</span>
              </a-col>
            </a-row>
          </li>
          <li>
            <span class="m-list-title" for>LKPD/SPPD No.</span>
            <span class="m-list-desc">{{ dtl.header.no_pdlk }}</span>
            <span class="m-list-desc">{{ dtl.header.no_sppd }}</span>
          </li>
        </ul>
      </a-col>
    </a-row>
    <a-table
      :rowKey="(record, index) => {return index;}"
      :columns="columns"
      :dataSource="dtl.dtl_kegiatan"
      :pagination="pagination"
      size="small"
      bordered
      class="table-dtl margin-top"
    >
      <template slot="activity" slot-scope="item">
        {{ moment(item.tanggal).format("DD-MM-YYYY") }}
      </template>
        <template slot="desc" slot-scope="item">
        {{ item.kegiatan }}
      </template>
      <template slot="typePD" slot-scope="item">
        {{ item.tipe=='LN' ? 'Luar Negeri' : 'Dalam Negeri' }}
      </template>
      <template slot="er" slot-scope="item">
        {{ formatCurrency('IDR',item.kurs?Number(item.kurs):1) }}
      </template>
      <template slot="insentive" slot-scope="item">
        {{ item.tipe=='DN' ? formatCurrency('IDR',item.insentif_pd) : formatCurrency('USD',item.insentif_luar_negeri) }}
      </template>
    </a-table>
  </a-modal>
</template>
<script>
import { mapGetters } from "vuex";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";
import axios from "axios";
import moment from "moment";

export default {
  name: "DialogDetil",
  props: ["visible","dtl"],
  mixins: [CurrencyFormat,GlobalMethod],
  data(){
    const columns = [
      {
        title: "Activity Date",
        key: "activity",
        width: "120px",
        align: "center",
        scopedSlots: { customRender: "activity" },
        sorter: (a, b) => a.tanggal - b.tanggal,
      },
      {
        title: "Activity Desc",
        key: "desc",
        scopedSlots: { customRender: "desc" },
        sorter: (a, b) => a.kegiatan - b.kegiatan,
      },
      {
        title: "PD Type",
        key: "typePD",
        width: "180px",
        align: "left",
        scopedSlots: { customRender: "typePD" },
        sorter: (a, b) => a.tipe - b.tipe,
      },
      {
        title: "Exchange Rate",
        key: "er",
        align: "right",
        scopedSlots: { customRender: "er" },
        sorter: (a, b) => a.kurs - b.kurs,
      },
      {
        title: "Insentive Value",
        key: "insentive",
        align: "right",
        scopedSlots: { customRender: "insentive" },
      },
    ]
    return {
      columns,
      loading: {
        confirm: false
      },
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
    }
  },
  computed: {
    ...mapGetters(["getScreen", "getAuth"]),
  },
  methods:{
    moment,
    process(){

    },
    cancel(){
      Event.$emit("closeDiagDtl");
    }
  }
}
</script>
<style lang="less">
.table-dtl{
  th{
    text-align: center!important;
  }
}
</style>